import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Spinner, Button } from "react-bootstrap";
import MonthlyCalendar from "./MontlyCalender";
import { useSelector } from "react-redux";

const HomeCompliance = ({ isTeamLeadView }) => {
    const userState = useSelector((state) => state.loginData.userData);

    const [loader, setLoader] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [employeeId, setEmployeeId] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    useEffect(() => {
        getHomeCompliance();
    }, [month, year, employeeId]);

    const getHomeCompliance = async () => {
        setLoader(true);
        try {
            const response = await fetch(
                process.env.REACT_APP_BASE_URL + "/task/get/alltask/compailanceTL",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${userState?.token}`,
                    },
                    body: JSON.stringify({
                        empId: isTeamLeadView && userState.empId,
                        month: month,
                        year: year,
                        proposedStartDate: fromDate,
                        proposedEndDate: toDate,
                    }),
                }
            );

            const res = await response.json();
            if (res.status === 200) {
                setTasks(res.data);
            }
        } catch (Err) {
            console.log("Error while compliance =>", Err);
        } finally {
            setLoader(false);
        }
    };

    return (
        <Container className="outletPadding">
            <Row className="my-5 align-items-end">
                <Col xs={12} md={6}>
                    <Row>
                        <Col xs={12} md={4}>
                            <Form.Label>From Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={fromDate || ""}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </Col>

                        <Col xs={12} md={4}>
                            <Form.Label>To Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={toDate || ""}
                                onChange={(e) => setToDate(e.target.value)}
                            />
                        </Col>

                        <Col xs={12} md={4} className="d-flex align-items-end">
                            <Button
                                className="primaryBtn "
                                onClick={() => {
                                    getHomeCompliance();
                                }}
                            >
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Col>

                <Col xs={12} md={6} className="d-flex justify-content-end gap-2 mt-3 mt-md-0">
                    <Form.Select
                        style={{ width: "150px" }}
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                    >
                        {Array.from({ length: 12 }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                                {new Date(0, i).toLocaleString("default", { month: "long" })}
                            </option>
                        ))}
                    </Form.Select>

                    <Form.Select
                        style={{ width: "120px" }}
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                    >
                        {[...Array(2)].map((_, i) => (
                            <option key={i} value={new Date().getFullYear() - i}>
                                {new Date().getFullYear() - i}
                            </option>
                        ))}
                    </Form.Select>
                </Col>
            </Row>

            {/* Calendar */}
            {loader ? (
                <div className="text-center my-4">
                    <Spinner size="lg" />
                </div>
            ) : (
                <MonthlyCalendar
                    key={employeeId}
                    year={year}
                    month={month}
                    tasks={tasks}
                    employeeId={employeeId}
                    employees={""}
                    onLeaveApplied={""}
                />
            )}
        </Container>
    );
};

export default HomeCompliance;
